(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["mot-faq-directory"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('mot-faq-directory')) {
  customElements.define('mot-faq-directory', class extends HTMLElement {
    connectedCallback() {
      if (this.abort) return;
      this.abort = new AbortController();
      const options = {signal:this.abort.signal};
      this.links = Array.from(this.querySelectorAll('[data-faq-topic]'));
      this.groups = Array.from(this.querySelectorAll('[data-faq-group]'));
      this.input = this.querySelector('[data-faq-search]');
      this.clear = this.querySelector('[data-faq-clear]');
      this.status = this.querySelector('[data-faq-status]');
      this.questions = Array.from(this.querySelectorAll('.mot-faq__question'));
      this.querySelector('.mot-faq__search').hidden = false;
      const normalize = text => text.normalize('NFKD').replace(/[\u0300-\u036f]/g,'').toLowerCase().replace(/[^a-z0-9]+/g,' ').trim();
      this.index = new Map(this.questions.map(question => [question, normalize(question.textContent)]));
      const search = () => {
        const terms = normalize(this.input.value).split(' ').filter(Boolean);
        this.clear.hidden = !this.input.value;
        if(!terms.length){this.show(this.category || 'shipping');return;}
        let count = 0;
        this.questions.forEach(question => {
          const match = terms.every(term => this.index.get(question).includes(term));
          question.hidden = !match;
          if(match)count++;
        });
        this.groups.forEach(group => {group.hidden = !Array.from(group.querySelectorAll('details')).some(question => !question.hidden);});
        this.links.forEach(link => link.setAttribute('aria-current','false'));
        this.status.hidden = false;
        this.status.textContent = count ? count + ' ' + (count === 1 ? this.status.dataset.resultLabel.replace(/s$/, '') : this.status.dataset.resultLabel) : this.status.dataset.emptyLabel;
      };
      this.input.addEventListener('input',search,options);
      this.input.addEventListener('keydown',event => {if(event.key==='Escape'){this.input.value='';search();}},options);
      this.clear.addEventListener('click',()=>{this.input.value='';search();this.input.focus();},options);
      this.show = (category) => {
        this.category = category;
        this.input.value = '';
        this.clear.hidden = true;
        this.status.hidden = true;
        this.questions.forEach(question => {question.hidden = false;});
        this.groups.forEach(group => {group.hidden = group.dataset.faqGroup !== category;});
        this.links.forEach(link => {link.setAttribute('aria-current',String(link.dataset.faqTopic === category));});
      };
      this.fromHash = () => {
        const target = document.getElementById(decodeURIComponent(location.hash.slice(1)));
        const group = target && this.contains(target) ? target.closest('[data-faq-group]') : null;
        if(group){this.show(group.dataset.faqGroup);if(target.matches('details'))target.open=true;}
      };
      this.links.forEach(link => link.addEventListener('click',event => {
        event.preventDefault();
        this.show(link.dataset.faqTopic);
        history.replaceState(null,'',link.getAttribute('href'));
      },options));
      window.addEventListener('hashchange',this.fromHash,options);
      document.addEventListener('shopify:block:select',event => {
        if(!this.contains(event.target))return;
        const group=event.target.closest('[data-faq-group]');
        if(group)this.show(group.dataset.faqGroup);
        const details=event.target.closest('details');
        if(details)details.open=true;
      },options);
      if(this.groups.length)this.show(this.groups[0].dataset.faqGroup);
      this.fromHash();
    }
    disconnectedCallback(){this.abort?.abort();this.abort=null;}
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["mot-journal"] && !Shopify.designMode) return;
  try {
    
function setupMotJournals(){
document.querySelectorAll('.mot-journal').forEach(section=>{
if(section.dataset.carouselReady)return;
section.dataset.carouselReady='true';
const grid=section.querySelector('.mot-journal__grid');
const prev=section.querySelector('[data-journal-prev]');
const next=section.querySelector('[data-journal-next]');
if(!grid||!prev||!next)return;
const update=()=>{prev.disabled=grid.scrollLeft<2;next.disabled=grid.scrollLeft+grid.clientWidth>=grid.scrollWidth-2;};
prev.addEventListener('click',()=>grid.scrollBy({left:-grid.clientWidth,behavior:matchMedia('(prefers-reduced-motion: reduce)').matches?'instant':'smooth'}));
next.addEventListener('click',()=>grid.scrollBy({left:grid.clientWidth,behavior:matchMedia('(prefers-reduced-motion: reduce)').matches?'instant':'smooth'}));
grid.addEventListener('scroll',update,{passive:true});
new ResizeObserver(update).observe(grid);
update();
});
}
setupMotJournals();
document.addEventListener('shopify:section:load',setupMotJournals);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["mot-new-releases"] && !Shopify.designMode) return;
  try {
    
(()=>{function init(scope){scope.querySelectorAll('.mot-releases:not([data-ready])').forEach(section=>{section.dataset.ready='true';const track=section.querySelector('.mot-releases__track');const buttons=section.querySelectorAll('[data-direction]');const update=()=>{const max=Math.max(0,track.scrollWidth-track.clientWidth);buttons.forEach(b=>{b.disabled=Number(b.dataset.direction)<0?track.scrollLeft<2:track.scrollLeft>=max-2;});const fill=section.querySelector('.mot-releases__progress>span');const count=track.children.length;if(fill)fill.style.width=(max>0?(1/count+(1-1/count)*Math.min(1,Math.max(0,track.scrollLeft/max)))*100:100)+'%';};buttons.forEach(b=>b.addEventListener('click',()=>{const card=track.querySelector('.mot-releases__card');track.scrollBy({left:Number(b.dataset.direction)*card.getBoundingClientRect().width,behavior:matchMedia('(prefers-reduced-motion: reduce)').matches?'instant':'smooth'});}));track.addEventListener('scroll',update,{passive:true});new ResizeObserver(update).observe(track);update();});}init(document);document.addEventListener('shopify:section:load',()=>init(document));})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["mot-review-intro"] && !Shopify.designMode) return;
  try {
    
// Use the same product-scoped photo feed and review viewer as Loox's dynamic carousel.
(() => {
  const initialize = async (gallery) => {
    if (gallery.dataset.initialized) return;
    gallery.dataset.initialized = 'true';
    for (let attempt = 0; attempt < 100; attempt++) {
      if (!gallery.isConnected) return;
      if (window.LOOX?.clientId && window.LOOX?.root && window.LOOX?.openQV) break;
      await new Promise(resolve => setTimeout(resolve, 250));
    }
    const loox = window.LOOX;
    if (!loox?.clientId || !loox?.root || !loox?.openQV) return;
    try {
      const productId = gallery.dataset.productId;
      const endpoint = new URL(`/widget/${loox.clientId}/dynamic-carousel/reviews/`, loox.root);
      endpoint.searchParams.set('h', loox.hash);
      if (productId) endpoint.searchParams.set('productId', productId);
      if (loox.multilingual) endpoint.searchParams.set('locale', loox.shopifyLocale);
      const response = await fetch(endpoint);
      if (!response.ok) return;
      const payload = await response.json();
      const group = payload.data?.[productId || 'agg'];
      if (!group || group.demo || !Array.isArray(group.reviews) || !gallery.isConnected) return;
      const reviews = group.reviews.filter(review => review.id && (review.midImage || review.poster));
      if (!reviews.length) { gallery.hidden = true; return; }
      const track = gallery.querySelector('.mot-review-intro__photo-track');
      reviews.forEach(review => {
        const item = document.createElement('div');
        item.className = 'mot-review-intro__photo-item';
        item.hidden = true;
        item.setAttribute('role', 'listitem');
        const button = document.createElement('button');
        button.type = 'button';
        button.className = 'mot-review-intro__photo';
        button.setAttribute('aria-label', `${review.reviewer || ''}: ${review.altText || review.productName || ''}`);
        const image = document.createElement('img');
        image.src = review.midImage || review.poster;
        image.alt = review.altText || '';
        image.width = image.height = 120;
        image.loading = 'eager';
        image.addEventListener('load', () => {
          item.hidden = false;
          update();
        });
        button.append(image);
        const caption = document.createElement('span');
        caption.className = 'mot-review-intro__photo-caption';
        caption.setAttribute('aria-hidden', 'true');
        const name = document.createElement('span');
        name.className = 'mot-review-intro__photo-name';
        name.textContent = `${review.reviewer || ''}${review.verified ? ' ✓' : ''}`;
        const stars = document.createElement('span');
        stars.className = 'mot-review-intro__photo-stars';
        const rating = Math.min(5, Math.max(0, Math.round(Number(review.rating) || 0)));
        stars.textContent = '★'.repeat(rating) + '☆'.repeat(5 - rating);
        caption.append(name, stars);
        button.append(caption);
        button.addEventListener('click', () => loox.openQV(review.id));
        item.append(button);
        track.append(item);
      });
      gallery.querySelector('.mot-review-intro__gallery-fallback').hidden = true;
      gallery.querySelector('.mot-review-intro__photo-strip').hidden = false;
      const arrows = [...gallery.querySelectorAll('[data-photo-direction]')];
      const update = () => {
        const max = track.scrollWidth - track.clientWidth;
        gallery.querySelector('.mot-review-intro__photo-controls').hidden = max < 2;
        arrows.forEach(arrow => {
          arrow.hidden = max < 2;
          arrow.disabled = Number(arrow.dataset.photoDirection) < 0 ? track.scrollLeft < 2 : track.scrollLeft >= max - 2;
        });
      };
      arrows.forEach(arrow => arrow.addEventListener('click', () => {
        const count = Math.max(1, Math.floor(track.clientWidth / 132) - 1);
        track.scrollBy({ left: Number(arrow.dataset.photoDirection) * count * 132, behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth' });
      }));
      track.addEventListener('scroll', update, { passive: true });
      new ResizeObserver(update).observe(track);
      update();
    } catch (error) {
      // The native gallery remains available if Loox's photo feed cannot load.
    }
  };
  const start = root => root.querySelectorAll('[data-mot-review-gallery]').forEach(initialize);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => start(document));
  else start(document);
  document.addEventListener('shopify:section:load', event => start(event.target));
})();


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["mot-signup-form"] && !Shopify.designMode) return;
  try {
    
  function punctuateMotSignup(root = document) {
    root.querySelectorAll('.mot-signup-page__forms').forEach((container) => {
      if (container.dataset.punctuationReady) return;
      container.dataset.punctuationReady = 'true';
      const update = () => {
        container.querySelectorAll('.klaviyo-form-richtext p').forEach((paragraph) => {
          const text = paragraph.textContent.replace(/\s+/g, ' ').trim();
          if (text === 'Don’t wait any longer. Sign up today and be the first to hear about new releases and special promotions.' ||
              text === 'Sign up today and be the first to hear about new releases and special promotions.') {
            paragraph.textContent = 'Sign up today and be the first to hear about secret sales, first looks + more!';
          }
        });
        container.querySelectorAll('h1').forEach((heading) => {
          const walker = document.createTreeWalker(heading, NodeFilter.SHOW_TEXT);
          let node;
          while ((node = walker.nextNode())) {
            const corrected = node.nodeValue.replace('New Releases Early Access', 'New Releases, Early Access');
            if (corrected !== node.nodeValue) node.nodeValue = corrected;
          }
        });
      };
      new MutationObserver(update).observe(container, { childList: true, subtree: true, characterData: true });
      update();
    });
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => punctuateMotSignup(), { once: true });
  } else {
    punctuateMotSignup();
  }
  document.addEventListener('shopify:section:load', (event) => punctuateMotSignup(event.target));

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["mot-trade"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('mot-trade-carousel')) {
  customElements.define('mot-trade-carousel', class extends HTMLElement {
    connectedCallback() {
      if (this.abort) return;
      this.abort = new AbortController();
      const track = this.querySelector('.mot-trade__track');
      const previous = this.querySelector('[data-previous]');
      const next = this.querySelector('[data-next]');
      const slides = [...track.children];
      const index = () => Math.round(track.scrollLeft / track.clientWidth);
      const update = () => {
        previous.disabled = index() <= 0;
        next.disabled = index() >= slides.length - 1;
      };
      const go = (step) => track.scrollTo({left: Math.max(0, Math.min(slides.length - 1, index() + step)) * track.clientWidth, behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth'});
      const options = {signal: this.abort.signal};
      previous.addEventListener('click', () => go(-1), options);
      next.addEventListener('click', () => go(1), options);
      track.addEventListener('scroll', update, {...options, passive:true});
      track.addEventListener('keydown', e => {
        if (e.key === 'ArrowRight' || e.key === 'ArrowLeft') {e.preventDefault();go(e.key === 'ArrowRight' ? 1 : -1);}
      }, options);
      this.addEventListener('shopify:block:select', e => {
        const slide = e.target.closest('.mot-trade__project');
        if (slide) track.scrollTo({left:slide.offsetLeft-track.offsetLeft,behavior:'instant'});
      }, options);
      this.resize = new ResizeObserver(update);
      this.resize.observe(track);
      update();
    }
    disconnectedCallback() {this.abort?.abort();this.abort=null;this.resize?.disconnect();}
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["mot-values-pill"] && !Shopify.designMode) return;
  try {
    
(() => {
  const mobile = matchMedia('(max-width:749px)');
  const reduced = matchMedia('(prefers-reduced-motion:reduce)');
  const start = root => root.querySelectorAll('.mot-values').forEach(section => {
    if (section.dataset.rotationReady) return;
    section.dataset.rotationReady = 'true';
    const items = [...section.querySelectorAll('.mot-values__item')];
    if (items.length < 2) return;
    let index = 0;
    const timer = setInterval(() => {
      if (!section.isConnected) { clearInterval(timer); return; }
      if (!mobile.matches || reduced.matches || document.hidden) return;
      items[index].classList.remove('is-active');
      index = (index + 1) % items.length;
      items[index].classList.add('is-active');
    }, 4500);
    section.addEventListener('shopify:block:select', event => {
      const selected = items.indexOf(event.target);
      if (selected < 0) return;
      items[index].classList.remove('is-active');
      index = selected;
      items[index].classList.add('is-active');
    });
  });
  start(document);
  document.addEventListener('shopify:section:load', event => start(event.target));
})();

  } catch(e) { console.error(e); }
})();
})();
